<template>
    <div @click="toggleFavourite" class="h-6 w-6">
        <template v-if="favourite">
            <figure class="h-6 w-6 cursor-pointer flex items-center justify-center">
                <v-icon
                    icon="heart-solid"
                    size="6"
                    class="text-salmon stroke-[0.6px] stroke-green"
                ></v-icon>
            </figure>
        </template>
        <template v-else>
            <v-icon
                icon="heart"
                size="6"
                class="text-green opacity-80 hover:opacity-100 stroke-[0.6px] stroke-green"
            ></v-icon>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        estateOnofficeId: {
            type: Number,
            required: true,
        },
        toggleFavoriteRoute: {
            type: String,
            required: true,
        },
        isFavorite: {
            type: Boolean,
            required: true,
        }
    },
    mounted() {
        this.favourite = this.isFavorite;
    },
    data() {
        return {
            favourite: false,
        };
    },
    methods: {
        toggleFavourite() {
            let data = {
                on_office_id: this.estateOnofficeId
            }

            axios
                .post(this.toggleFavoriteRoute, data, {
                    headers: {
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.favourite = response.data.status;
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        },
    },
};
</script>
